import { render, staticRenderFns } from "./addCloudaliupdatetask.vue?vue&type=template&id=13a8d086"
import script from "./addCloudaliupdatetask.vue?vue&type=script&lang=js"
export * from "./addCloudaliupdatetask.vue?vue&type=script&lang=js"
import style0 from "./addCloudaliupdatetask.vue?vue&type=style&index=0&id=13a8d086&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a8d086')) {
      api.createRecord('13a8d086', component.options)
    } else {
      api.reload('13a8d086', component.options)
    }
    module.hot.accept("./addCloudaliupdatetask.vue?vue&type=template&id=13a8d086", function () {
      api.rerender('13a8d086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rabbit/addCloudaliupdatetask.vue"
export default component.exports